import media from 'style-utils/responsive-utils/media/media';
import styled from 'styled-components';

export const RegistrationCard = styled.div`
  display: flex;
  max-width: 96rem;
  margin: 0 auto;
  border-radius: 0.7rem;
  background: #ffffff;
  ${media.desktop`
    overflow:hidden;
    margin:5.2rem auto 0;
    height: 81.2rem;
    border: 1px solid #eeeeee;

  `}
`;

RegistrationCard.displayName = 'RegistrationCard';
